import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../material.module';
import { Routes } from "@angular/router";
import { EventEmitter } from '@angular/core';
import { NotesofaccountsComponent } from '../notesofaccounts.component';

@Component({
  selector: 'app-note6',
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, NotesofaccountsComponent],
  templateUrl: './note6.component.html',
  styleUrl: './note6.component.scss'
})
export class Note6Component {


  constructor(private router: Router, private ParentCoponent: NotesofaccountsComponent) {
    alert('child')
  }
  ngOnInit(): void {
    alert('ngonit')
    this.SaveandNextNote(this.selectedNoteFromParent, false)
  }
  selectNotes: boolean = true; selectedNotes: boolean = false;

  CurrentNote: string;
  CurrentNoteisactive: string;

  note20: boolean = false; isActive20: boolean = false; note21: boolean = false; isActive21: boolean = false; note22: boolean = false; isActive22: boolean = false;
  note23: boolean = false; isActive23: boolean = false;


  @Output() childClicked = new EventEmitter<string>(); // Emits a string
  @Input() selectedNoteFromParent: string; // This receives data from the parent
  emitClickEvent(CurrentNote: any) {
    this.childClicked.emit(CurrentNote);
  }

  displayedColumns: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'UnrestrictedLastYear', 'RestrictedLastYear', 'EndowmentLastYear', 'TotalLastYear',];
  secondaryFooterDisplayedColumns: string[] = ['AnalysisFooter', 'UnrestrictedFooter', 'RestrictedFooter', 'EndowmentFooter', 'TotalFooter', 'UnrestrictedLastYearFooter', 'RestrictedLastYearFooter', 'EndowmentLastYearFooter', 'TotalLastYearFooter',];
  thirdFooterDisplayedColumns: string[] = ['AnalysisDiffFooter', 'UnrestrictedDiffFooter', 'RestrictedDiffFooter', 'EndowmentDiffFooter', 'TotalDiffFooter', 'UnrestrictedDiffLastYearFooter', 'RestrictedDiffLastYearFooter', 'EndowmentDiffLastYearFooter', 'TotalDiffLastYearFooter',];
  data: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
    { type: 'Incurred seeking legacies', Description: '', Year: '' },
    { type: 'Incurred seeking grants', Description: '', Year: '' },
    { type: 'Operating membership schemes and social lotteries', Description: '', Year: '' },
    { type: 'Staging fundraising events', Description: '', Year: '' },
    { type: 'Fudraising agents', Description: '', Year: '' },
    { type: 'Operating charity shops', Description: '', Year: '' },
    { type: 'Operating a trading company undertaking non-charitable trading activity', Description: '', Year: '' },
    { type: 'Advertising, marketing, direct mail and publicity', Description: '', Year: '' },
    { type: 'Start up costs incurred in generating new source of future income', Description: '', Year: '' },
    { type: 'Database development costs', Description: '', Year: '' },
    { type: 'Other trading activities', Description: '', Year: '' },
    { type: 'Investment management costs', Description: '', Year: '' },
    { type: 'Portfolio management costs', Description: '', Year: '' },
    { type: 'Cost of obtaining investment advice', Description: '', Year: '' },
    { type: 'Intellectual property licencing costs', Description: '', Year: '' },
    { type: 'Rent collection, property repairs and maintenance charges', Description: '', Year: '' },
  ];

  displayedColumns2: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'UnrestrictedLastYear', 'RestrictedLastYear', 'EndowmentLastYear', 'TotalLastYear',];
  displayedMainColumns2: string[] = ['particulars','ThisYear', 'LastYear'];
  data2: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
  ];

  displayedColumns3: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'UnrestrictedLastYear', 'RestrictedLastYear', 'EndowmentLastYear', 'TotalLastYear',];
  displayedMainColumns3: string[] = ['particulars', 'ThisYear', 'LastYear'];
  data3: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
  ];

  displayedColumns4: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'UnrestrictedLastYear', 'RestrictedLastYear', 'EndowmentLastYear', 'TotalLastYear',];
  displayedMainColumns4: string[] = ['particulars', 'ThisYear', 'LastYear'];
  data4: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
  ];

  BackNote() {
    debugger
    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    currentNoteNumber = this.CurrentNote.split('note')[1]
    currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

    NextNoteisactive = `isActive${+currentNoteisactive - 1}`
    NextNoteNumvber = `note${+currentNoteNumber - 1}`
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)
  }
  SaveandNextNote(note?: any, IsNextClick?: any) {
    debugger

    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    if (IsNextClick == false) {
      var Parentnote = this.selectedNoteFromParent.split('/')
      currentNoteNumber = Parentnote[0].split('note')[1]
      currentNoteisactive = Parentnote[1].split('isActive')[1]
      NextNoteNumvber = `note${+currentNoteNumber}`

      this.CurrentNote = NextNoteNumvber
      NextNoteisactive = `isActive${+currentNoteisactive}`
    }
    else {

      currentNoteNumber = this.CurrentNote ? this.CurrentNote.split('note')[1] : note.split('note')[1]
      currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

      NextNoteisactive = `isActive${+currentNoteisactive + 1}`
      NextNoteNumvber = `note${+currentNoteNumber + 1}`
    }
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)

  }

  ClickSelectedNote(note: string, IsActive?: any): void {
    debugger
    this.note20 = false;
    this.isActive20 = false;
    (this as any)[note] = true;

    // this.emitClickEvent(this.CurrentNote)
    this.CurrentNoteisactive = IsActive
    this.CurrentNote = note


  }

  SaveAndNext() {
    debugger
    var currentNoteNumber = this.CurrentNote.split('note')[1]
    // var currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]
    var NextNoteNumvber = `note${+currentNoteNumber + 1}`
    // var NextNoteisactive = `isActive${+currentNoteisactive + 1}`
    //   this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    // this.router.navigate([''])
  }
}
